/* ─── Список бажаного ────────────────────────────────────────────
   Працює так само, як у COS: серце на фото товару додає його
   до списку, серце в хедері веде на сторінку зі списком.

   ⚠️ Список зберігається В БРАУЗЕРІ покупця (localStorage).
   Це означає: він переживає перезавантаження й закриття вкладки,
   але не переноситься на інший пристрій і не прив'язаний до
   акаунта. Так працює будь-який список бажаного без окремого
   платного застосунку.

   Ключ у пам'яті: hms_wishlist
   Формат: [{handle, title, url, price, image}]
─────────────────────────────────────────────────────────────── */
(function () {
  var КЛЮЧ = 'hms_wishlist';

  function прочитати() {
    try {
      var дані = JSON.parse(localStorage.getItem(КЛЮЧ));
      return Array.isArray(дані) ? дані : [];
    } catch (e) {
      return [];
    }
  }

  function записати(список) {
    try {
      localStorage.setItem(КЛЮЧ, JSON.stringify(список));
    } catch (e) {
      /* пам'ять переповнена або заблокована — мовчки пропускаємо */
    }
    оновитиЛічильник();
    document.dispatchEvent(new CustomEvent('wishlist:changed'));
  }

  function єВСписку(handle) {
    return прочитати().some(function (т) { return т.handle === handle; });
  }

  function перемкнути(дані) {
    var список = прочитати();
    var і = список.findIndex(function (т) { return т.handle === дані.handle; });
    if (і > -1) {
      список.splice(і, 1);
    } else {
      список.unshift(дані);
    }
    записати(список);
    return і === -1;
  }

  /* ── Лічильник ──────────────────────────────────────────────
     Біля серця в хедері числа немає — так у COS. Функція
     лишається на випадок, якщо колись захочемо його повернути:
     достатньо додати в розмітку елемент [data-wishlist-count]. */
  function оновитиЛічильник() {
    var кількість = прочитати().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (вузол) {
      вузол.textContent = кількість;
      var бульбашка = вузол.closest('.wishlist-count-bubble');
      if (бульбашка) бульбашка.hidden = кількість === 0;
    });
  }

  /* ── Стан усіх кнопок на сторінці ──────────────────────────── */
  function оновитиКнопки() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (кнопка) {
      var усередині = єВСписку(кнопка.dataset.handle);
      кнопка.classList.toggle('is-active', усередині);
      кнопка.setAttribute('aria-pressed', усередині ? 'true' : 'false');
    });
  }

  /* ── Натиск на серце ───────────────────────────────────────── */
  document.addEventListener('click', function (подія) {
    var кнопка = подія.target.closest('[data-wishlist-toggle]');
    if (!кнопка) return;
    подія.preventDefault();
    подія.stopPropagation();
    перемкнути({
      handle: кнопка.dataset.handle,
      title: кнопка.dataset.title,
      url: кнопка.dataset.url,
      price: кнопка.dataset.price,
      image: кнопка.dataset.image
    });
    оновитиКнопки();
  });

  /* ── Сторінка зі списком ─────────────────────────────────────
     Картка повторює COS: фото 2:3, хрестик «прибрати» у білому
     кружечку, назва, ціна, а знизу пара «розмір + Add to bag».

     Дані про розміри беремо з самого магазину (/products/…js),
     а не з пам'яті браузера: у списку може лежати товар,
     доданий місяць тому, і його розміри вже могли скінчитись. */

  var КЕШ = {};

  function завантажитиТовар(handle) {
    if (КЕШ[handle]) return КЕШ[handle];
    КЕШ[handle] = fetch(window.Shopify.routes.root + 'products/' + handle + '.js')
      .then(function (в) { return в.ok ? в.json() : null; })
      .catch(function () { return null; });
    return КЕШ[handle];
  }

  function екранувати(текст) {
    return String(текст == null ? '' : текст)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function розміткаКартки(т) {
    var хрестик = document.querySelector('[data-wishlist-close-icon]');
    return (
      '<li class="wishlist-item" data-handle="' + екранувати(т.handle) + '">' +
        '<div class="wishlist-item__frame">' +
          '<a class="wishlist-item__media" href="' + екранувати(т.url) + '">' +
            (т.image ? '<img src="' + екранувати(т.image) + '" alt="" loading="lazy">' : '') +
          '</a>' +
          '<button type="button" class="wishlist-item__remove"' +
            ' data-wishlist-toggle data-handle="' + екранувати(т.handle) + '"' +
            ' aria-label="Remove from wishlist">' +
            (хрестик ? хрестик.innerHTML : '&times;') +
          '</button>' +
        '</div>' +
        '<a class="wishlist-item__title" href="' + екранувати(т.url) + '">' + екранувати(т.title) + '</a>' +
        '<div class="wishlist-item__price">' + екранувати(т.price || '') + '</div>' +
        '<div class="wishlist-item__buy" data-buy hidden>' +
          '<div class="wishlist-item__size" data-size-wrap>' +
            '<button type="button" class="wishlist-item__select" data-size-toggle' +
              ' aria-haspopup="listbox" aria-expanded="false" aria-label="Size">' +
              '<span data-size-current></span>' +
              '<svg class="wishlist-item__chevron" width="10" height="6" viewBox="0 0 10 6"' +
                ' fill="none" aria-hidden="true"><path d="M1 1l4 4 4-4" stroke="currentColor"' +
                ' stroke-width="1"/></svg>' +
            '</button>' +
            '<ul class="wishlist-item__list" data-size-list role="listbox" hidden></ul>' +
          '</div>' +
          '<button type="button" class="wishlist-item__add" data-add>Add to bag</button>' +
        '</div>' +
      '</li>'
    );
  }

  /* Заповнюємо картку справжніми розмірами. Поки товар вантажиться,
     рядок покупки прихований — щоб не блимав порожній список. */
  function доповнитиКартку(картка) {
    завантажитиТовар(картка.dataset.handle).then(function (товар) {
      var рядок = картка.querySelector('[data-buy]');
      if (!товар) {
        /* Товару більше немає в магазині — лишаємо картку без кнопки. */
        return;
      }
      var список = картка.querySelector('[data-size-list]');
      var перемикач = картка.querySelector('[data-size-toggle]');
      var кнопка = картка.querySelector('[data-add]');
      var єВНаявності = товар.variants.some(function (в) { return в.available; });

      список.innerHTML = товар.variants.map(function (в) {
        return '<li class="wishlist-item__option' + (в.available ? '' : ' is-gone') + '"' +
          ' role="option" data-value="' + в.id + '"' +
          ' aria-disabled="' + (в.available ? 'false' : 'true') + '">' +
          екранувати(в.title) + (в.available ? '' : ' — out of stock') +
          '</li>';
      }).join('');

      var перший = товар.variants.find(function (в) { return в.available; });
      if (перший) обратиРозмір(картка, перший.id, перший.title);

      /* Один розмір — вибирати нема з чого, кнопка на всю ширину. */
      if (товар.variants.length < 2) {
        картка.querySelector('[data-size-wrap]').hidden = true;
        рядок.classList.add('wishlist-item__buy--single');
      }

      if (!єВНаявності) {
        кнопка.textContent = 'Out of stock';
        кнопка.disabled = true;
        перемикач.disabled = true;
      }

      рядок.hidden = false;
    });
  }

  /* ── Свій випадний список розмірів ─────────────────────────
     Рідне віконце браузера намалювати не можна — його малює
     операційна система. Тому робимо своє: кнопка з поточним
     розміром і список під нею, як у COS. */

  function обратиРозмір(картка, id, назва) {
    картка.dataset.variant = id;
    картка.querySelector('[data-size-current]').textContent = назва;
    картка.querySelectorAll('.wishlist-item__option').forEach(function (о) {
      о.classList.toggle('is-current', о.dataset.value === String(id));
      о.setAttribute('aria-selected', о.dataset.value === String(id) ? 'true' : 'false');
    });
  }

  function закритиСписки(крімКартки) {
    document.querySelectorAll('.wishlist-item.is-open').forEach(function (к) {
      if (к === крімКартки) return;
      к.classList.remove('is-open');
      к.querySelector('[data-size-list]').hidden = true;
      к.querySelector('[data-size-toggle]').setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (подія) {
    var перемикач = подія.target.closest('[data-size-toggle]');
    var пункт = подія.target.closest('.wishlist-item__option');

    if (перемикач) {
      var картка = перемикач.closest('.wishlist-item');
      var відкрито = картка.classList.contains('is-open');
      закритиСписки(картка);
      картка.classList.toggle('is-open', !відкрито);
      картка.querySelector('[data-size-list]').hidden = відкрито;
      перемикач.setAttribute('aria-expanded', відкрито ? 'false' : 'true');
      return;
    }

    if (пункт) {
      if (пункт.getAttribute('aria-disabled') === 'true') return;
      var к2 = пункт.closest('.wishlist-item');
      обратиРозмір(к2, пункт.dataset.value, пункт.textContent.trim());
      закритиСписки(null);
      return;
    }

    /* Клац повз список — закриваємо. */
    закритиСписки(null);
  });

  document.addEventListener('keydown', function (подія) {
    if (подія.key === 'Escape') закритиСписки(null);
  });

  /* ── Додати в кошик просто зі списку ───────────────────────── */
  function оновитиКошик() {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (в) { return в.json(); })
      .then(function (кошик) {
        document.querySelectorAll('[data-bag-count]').forEach(function (в) {
          в.textContent = кошик.item_count;
        });
      });

    /* Значок кошика в хедері перемальовуємо силами самої теми —
       так число й вигляд завжди збігаються з рештою сайту. */
    fetch(window.Shopify.routes.root + '?sections=cart-icon-bubble')
      .then(function (в) { return в.json(); })
      .then(function (д) {
        var місце = document.getElementById('cart-icon-bubble');
        if (!місце || !д['cart-icon-bubble']) return;
        var шматок = new DOMParser().parseFromString(д['cart-icon-bubble'], 'text/html');
        var розділ = шматок.querySelector('.shopify-section');
        if (розділ) місце.innerHTML = розділ.innerHTML;
      })
      .catch(function () { /* не критично */ });
  }

  document.addEventListener('click', function (подія) {
    var кнопка = подія.target.closest('[data-add]');
    if (!кнопка) return;
    var картка = кнопка.closest('.wishlist-item');
    if (!картка.dataset.variant) return;

    var було = кнопка.textContent;
    кнопка.disabled = true;
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(картка.dataset.variant), quantity: 1 }] })
    })
      .then(function (в) {
        if (!в.ok) throw new Error('відмова');
        кнопка.textContent = 'Added';
        оновитиКошик();
        /* Товар переїхав у кошик — зі списку бажаного він зникає,
           як у COS. Секунду тримаємо напис «Added», щоб покупець
           побачив, що сталося, і аж тоді прибираємо картку. */
        setTimeout(function () {
          прибратиЗіСписку(картка.dataset.handle);
        }, 1000);
      })
      .catch(function () {
        кнопка.textContent = 'Try again';
        setTimeout(function () {
          кнопка.textContent = було;
          кнопка.disabled = false;
        }, 2000);
      });
  });

  function прибратиЗіСписку(handle) {
    var список = прочитати().filter(function (т) { return т.handle !== handle; });
    записати(список);
    оновитиКнопки();
  }

  /* ── Запрошення створити акаунт ────────────────────────────── */
  var КЛЮЧ_ПРОМО = 'hms_wishlist_promo_closed';

  document.addEventListener('click', function (подія) {
    if (!подія.target.closest('[data-wishlist-promo-close]')) return;
    try { localStorage.setItem(КЛЮЧ_ПРОМО, '1'); } catch (e) {}
    var блок = document.querySelector('[data-wishlist-promo]');
    if (блок) блок.hidden = true;
  });

  function промоЗакрито() {
    try { return localStorage.getItem(КЛЮЧ_ПРОМО) === '1'; } catch (e) { return false; }
  }

  function намалюватиСписок() {
    var місце = document.querySelector('[data-wishlist-list]');
    if (!місце) return;
    var порожньо = document.querySelector('[data-wishlist-empty]');
    var промо = місце.querySelector('[data-wishlist-promo]');
    var список = прочитати();

    /* Прибираємо лише картки — запрошення створити акаунт
       намальоване Shopify і має лишитись на місці. */
    місце.querySelectorAll('.wishlist-item').forEach(function (в) { в.remove(); });

    місце.classList.toggle('wishlist-grid--empty', список.length === 0);
    if (промо) промо.hidden = список.length === 0 || промоЗакрито();
    if (порожньо) порожньо.hidden = список.length !== 0;
    if (!список.length) return;

    місце.insertAdjacentHTML('beforeend', список.map(розміткаКартки).join(''));
    місце.querySelectorAll('.wishlist-item').forEach(доповнитиКартку);
  }

  document.addEventListener('wishlist:changed', намалюватиСписок);

  function старт() {
    оновитиЛічильник();
    оновитиКнопки();
    намалюватиСписок();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', старт);
  } else {
    старт();
  }

  /* Список міг змінитись в іншій вкладці — тримаємо однаково. */
  window.addEventListener('storage', function (e) {
    if (e.key === КЛЮЧ) старт();
  });
})();
